import { render, staticRenderFns } from "./BetSlipItem.vue?vue&type=template&id=7bed5424&scoped=true&"
import script from "./BetSlipItem.vue?vue&type=script&lang=js&"
export * from "./BetSlipItem.vue?vue&type=script&lang=js&"
import style0 from "./BetSlipItem.vue?vue&type=style&index=0&id=7bed5424&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bed5424",
  null
  
)

export default component.exports